const initFormFields = (selector) => {
  var groupForm = [].slice.call(document.querySelectorAll(".form-group"));
  groupForm.map(function(groupFormField) {
    if (groupFormField) {
      const fields = [].slice.call(groupFormField.querySelectorAll(".form-control"));
      fields.map(function(field) {
        if (field) {
          field == null ? void 0 : field.addEventListener("input", function(e) {
            if (e.target.value !== "") {
              this.closest(".form-group").classList.add("not-empty");
            } else {
              this.closest(".form-group").classList.remove("not-empty");
            }
          });
        }
      });
    }
  });
  const gdprWrapper = $(".gdpr-wrapper");
  const gdpr = $("#gdpr_consent");
  if (gdprWrapper.length && gdpr.length) {
    gdprWrapper.append(gdpr);
  }
  var today = new Date();
  var expiry = new Date(today.getTime() + 30 * 24 * 3600 * 1e3);
  var setCookie = function(name, value) {
    document.cookie = name + "=" + escape(value) + "; path=/; expires=" + expiry.toUTCString();
  };
  const btnToSave = document.querySelector(".btn-to-save");
  let fieldEnterprise = document.querySelector(".to-save-enterprise");
  let fieldName = document.querySelector(".to-save-name");
  let fieldLastname = document.querySelector(".to-save-lastname");
  let fieldMail = document.querySelector(".to-save-mail");
  let fieldTel = document.querySelector(".to-save-tel");
  let fieldCity = document.querySelector(".to-save-city");
  let fieldZip = document.querySelector(".to-save-zip");
  if (btnToSave) {
    btnToSave == null ? void 0 : btnToSave.addEventListener("click", function(e) {
      if (fieldEnterprise)
        setCookie("enterprise", fieldEnterprise.value);
      if (fieldName)
        setCookie("name", fieldName.value);
      if (fieldLastname)
        setCookie("lastname", fieldLastname.value);
      if (fieldMail)
        setCookie("mail", fieldMail.value);
      if (fieldTel)
        setCookie("tel", fieldTel.value);
      if (fieldCity)
        setCookie("city", fieldCity.value);
      if (fieldZip)
        setCookie("zip", fieldZip.value);
    });
  }
  function getCookieValue(name) {
    const regex = new RegExp(`(^| )${name}=([^;]+)`);
    const match = document.cookie.match(regex);
    if (match) {
      return match[2];
    }
  }
  if (getCookieValue("enterprise") && btnToSave) {
    fieldEnterprise.value = getCookieValue("enterprise").replace("%E9", "\xE9").replace("%F4", "\xF4").replace("%E8", "\xE8").replace("%EF", "\xEF").replace("%20", " ").replace("%27", "'");
  }
  if (getCookieValue("name") && btnToSave) {
    fieldName.value = getCookieValue("name").replace("%E9", "\xE9").replace("%F4", "\xF4").replace("%E8", "\xE8").replace("%EF", "\xEF").replace("%20", " ").replace("%27", "'");
  }
  if (getCookieValue("lastname") && btnToSave) {
    fieldLastname.value = getCookieValue("lastname").replace("%E9", "\xE9").replace("%F4", "\xF4").replace("%E8", "\xE8").replace("%EF", "\xEF").replace("%20", " ").replace("%27", "'");
  }
  if (getCookieValue("mail") && btnToSave) {
    fieldMail.value = getCookieValue("mail").replace("%E9", "\xE9").replace("%F4", "\xF4").replace("%E8", "\xE8").replace("%EF", "\xEF").replace("%20", " ").replace("%27", "'");
  }
  if (getCookieValue("tel") && btnToSave) {
    fieldTel.value = getCookieValue("tel").replace("%E9", "\xE9").replace("%F4", "\xF4").replace("%E8", "\xE8").replace("%EF", "\xEF").replace("%20", " ").replace("%27", "'");
  }
  if (getCookieValue("city") && btnToSave) {
    fieldCity.value = getCookieValue("city").replace("%E9", "\xE9").replace("%F4", "\xF4").replace("%E8", "\xE8").replace("%EF", "\xEF").replace("%20", " ").replace("%27", "'");
  }
  if (getCookieValue("zip") && btnToSave) {
    fieldZip.value = getCookieValue("zip").replace("%E9", "\xE9").replace("%F4", "\xF4").replace("%E8", "\xE8").replace("%EF", "\xEF").replace("%20", " ").replace("%27", "'");
  }
};
export default initFormFields;
